import React from "react";
import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";

import SectionTitle from "../SectionTitle";

const MajorServices = () => {
  return (
    <>
      {/* ======= Featured Services Section ======= */}
      <section className="featured-services" id="makeMeBlack">
        <div className="container" data-aos="fade-up">
          <SectionTitle title={"Major Services"} />

          <div className="col-md-12 col-lg-12 d-flex align-items-stretch mb-lg-0 major-services ">
            <OwlCarousel
              items={4}
              className="owl-carousel"
              data-aos="fade-up"
              data-aos-delay="100"
              margin={8}
              nav={true}
              dots={false}
              loop
              autoplay={true}
              autoplayTimeout={4000}
              autoplayHoverPause={true}
              navText={[
                '<i className="icofont-navigation-menu " id="left-major-home" aria-hidden="false"><</i>',
                '<i className="icofont-navigation-menu" aria-hidden="true">></i>',
              ]}
              responsiveClass={true}
              responsive={{
                0: {
                  items: 1,
                  nav: true,
                },
                600: {
                  items: 3,
                  nav: false,
                },
                1000: {
                  items: 4,
                  nav: true,
                  loop: true,
                },
              }}
            >
              <a
                href="https://cutis-site.web.app/service/hair/hair-transplantation"
                target="_blank"
              >
                <div
                  className="majorServiceRowDiv icon-box"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div className="icon">
                    <img
                      src="/assets/img/home/major_services/major/hairtreatment.jpg"
                      className="rounded-circle imgRound bg-white m-auto"
                      alt=""
                    />
                  </div>
                  <h4 className="majorTitle">
                    <a href="https://cutis-site.web.app/service/hair/hair-transplantation">
                      Hair Transplant
                    </a>
                  </h4>
                  <p className="majorDescription">
                    CACS provides a permanent solution for hair loss, providing
                    a safe & relatively painless treatment to restore & grow
                    hair naturally.
                  </p>
                </div>
              </a>
              <a
                href="https://cutis-site.web.app/service/laser-hair-reduction"
                target="_blank"
              >
                <div
                  className="icon-box"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div className="icon">
                    <img
                      src="/assets/img/home/major_services/major/laserhair.jpg"
                      className="rounded-circle imgRound bg-white m-auto"
                      alt=""
                    />
                  </div>
                  <h4 className="majorTitle">
                    <a href="https://cutis-site.web.app/service/laser-hair-reduction">
                      Laser Hair Reduction
                    </a>
                  </h4>
                  <p className="majorDescription">
                    CACS offers four types of laser technology like IPL
                    (Ellipse), Alexandrite (Clarity), Nd:YAG (Fotona), and Diode
                    laser (Lumenis), to remove unwanted hair. It is a safe and
                    painless procedure and does not damage your skin.
                  </p>
                </div>
              </a>
              <a
                href="https://cutis-site.web.app/service/skin/pimples"
                target="_blank"
              >
                <div
                  className="icon-box"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div className="icon">
                    <img
                      src="/assets/img/home/major_services/major/acne.jpg"
                      className="rounded-circle imgRound bg-white m-auto"
                      alt=""
                    />
                  </div>
                  <h4 className="majorTitle">
                    <a href="https://cutis-site.web.app/service/skin/pimples">
                      Acne
                    </a>
                  </h4>
                  <p className="majorDescription">
                    Acne is one of the most common skin conditions that affect
                    both men & women. Depending on the severity of your acne,
                    CACS offers Chemical peels and lasers for active acne.
                  </p>
                </div>
              </a>
              <a
                href="https://cutis-site.web.app/service/anti-ageing"
                target="_blank"
              >
                <div
                  className="icon-box"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div className="icon">
                    <img
                      src="/assets/img/home/major_services/major/antiaging.jpg"
                      className="rounded-circle imgRound bg-white m-auto"
                      alt=""
                    />
                  </div>
                  <h4 className="majorTitle">
                    <a href="https://cutis-site.web.app/service/anti-ageing">
                      Anti-aging
                    </a>
                  </h4>
                  <p className="majorDescription">
                    CACS provides several treatments that will slow down &
                    reverse the aging process. (Different techniques are applied
                    depending on the type, texture & age of skin.)
                  </p>
                </div>
              </a>
              <a
                href="https://cutis-site.web.app/service/aesthetics/acne-scar"
                target="_blank"
              >
                <div
                  className="icon-box"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div className="icon">
                    <img
                      src="/assets/img/home/major_services/major/acnescars.jpg"
                      className="rounded-circle imgRound bg-white m-auto"
                      alt=""
                    />
                  </div>
                  <h4 className="majorTitle">
                    <a href="https://cutis-site.web.app/service/aesthetics/acne-scar">
                      Acne Scar
                    </a>
                  </h4>
                  <p className="majorDescription">
                    CACS specializes in treating all types of acne scars by
                    utilizing the surgical and nonsurgical modality of treatment
                  </p>
                </div>
              </a>
              <a
                href="https://cutis-site.web.app/service/aesthetics/skin-radiance"
                target="_blank"
              >
                <div
                  className="icon-box"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div className="icon">
                    <a href="https://cutis-site.web.app/service/aesthetics/skin-radiance">
                      <img
                        src="/assets/img/home/major_services/major/complexion.jpg"
                        className="rounded-circle imgRound bg-white m-auto"
                        alt=""
                      />
                    </a>
                  </div>
                  <h4 className="majorTitle">
                    <a href="https://cutis-site.web.app/service/aesthetics/skin-radiance">
                      Skin Radiance
                    </a>
                  </h4>

                  <p className="majorDescription">
                    Facial skin radiance is the most commonly sought desire of
                    the patients. Skin radiance adds to facial attractiveness,
                    boosts confidence, and improves the presentability of an
                    individual.
                  </p>
                </div>
              </a>

              <a
                href="https://cutis-site.web.app/service/skin/pigmentation"
                target="_blank"
              >
                <div
                  className="icon-box"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div className="icon">
                    <img
                      src="/assets/img/home/major_services/major/pigmentation.jpg"
                      className="rounded-circle imgRound bg-white m-auto"
                      alt=""
                    />
                  </div>
                  <h4 className="majorTitle">
                    <a href="https://cutis-site.web.app/service/skin/pigmentation">
                      Pigmentation
                    </a>
                  </h4>
                  <p className="majorDescription">
                    CACS offers various advanced treatment options for
                    Pigmentation that helps in reducing melanin content safely
                    and effectively
                  </p>
                </div>
              </a>
              {/*
              Laser toning procedure helps to tackle melasma,
                  sun spots, age spots, and uneven pigmentation. Chemical peels
                  are chosen depending on the cause, severity, and skin type

                            <div className="icon-box" data-aos="fade-up" data-aos-delay="100">
                            <div className="icon"><img src="/assets/img/home/major_services/05.jpg" className="rounded-circle imgRound bg-white m-auto" alt=""/></div>
                            <h4 className="majorTitle"><a href="/service/">Pediatric Dermatology</a></h4>
                            <p className="majorDescription">Latest treatments and technologies to care for a wide variety of skin, hair, and nail conditions vascular and pigmented birthmarks.</p>
                            </div>

                            <div className="icon-box" data-aos="fade-up" data-aos-delay="100">
                            <div className="icon"><img src="/assets/img/home/major_services/06.jpg" className="rounded-circle imgRound bg-white m-auto" alt=""/></div>
                            <h4 className="majorTitle"><a href="/service/">Body Shaping</a></h4>
                            <p className="majorDescription">Our treatments use nonsurgical, FDA-approved technologies to dissolve or melt fat, improve cellulite, and tighten and tone skin.</p>
                            </div>

                            <div className="icon-box" data-aos="fade-up" data-aos-delay="100">
                            <div className="icon"><img src="/assets/img/home/major_services/08.jpg" className="rounded-circle imgRound bg-white m-auto" alt=""/></div>
                            <h4 className="majorTitle"><a href="/service/">Nutrition</a></h4>
                            <p className="majorDescription">A balance of the right nutritive foods, nutritional supplements and moderate exercise regimen.Lorem ipsum, or lipsum as it is sometimes known</p>
                            </div>

                            <div className="icon-box" data-aos="fade-up" data-aos-delay="100">
                            <div className="icon"><img src="/assets/img/home/major_services/07.jpg" className="rounded-circle imgRound bg-white m-auto" alt=""/></div>
                            <h4 className="majorTitle"><a href="/service/">Hair</a></h4>
                            <p className="majorDescription">Safe and relatively painless procedure to restore and grow hairs naturally. Lorem ipsum, or lipsum as it is sometimes known as test content</p>
                            </div>
                            */}
            </OwlCarousel>
          </div>
        </div>
      </section>
      {/* End Featured Services Section */}

      {/* ======= Cta Section ======= 
            <section id="cta" className="cta">
            <div className="container" data-aos="zoom-in">

                <div className="text-center">
                <h3>In an emergency? Need help now?</h3>
                <p> Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                <a className="cta-btn scrollto" href="#appointment">Make an Appointment</a>
                {/* <Link className="cta-btn scrollto" to={{pathname:`/book-appointment`}}>Make an Appointment</Link> 
                </div>

            </div>
            </section>{/* End Cta Section */}
      {/* <div style="left:9vw;position:relative;">
        <i className="icofont-navigation-menu" aria-hidden="true">
          >
        </i>
      </div> */}
    </>
  );
};

export default MajorServices;
